export default {
    SUBTITLE: 'Add {{type}}',
    TITLE:'Do they have {{type}}?'
}